<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 點數分析</b-col>
      <b-col>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>全國</legend>
              <h4>累積點數查詢</h4>
              <div class="p-4 box-shadow">
                <b-form-radio-group v-model="earnQuery.rdoPoint">
                  <form class="row" @submit.prevent="getEarnData">
                    <div class="col-lg-12">
                      <b-form-radio value="1">總累積點數</b-form-radio>
                    </div>
                    <div class="col-lg-2 mt-3">
                      <b-form-radio value="2">區間累積點數</b-form-radio>
                    </div>
                    <div class="col-lg-3 mt-2">
                      <input type="date" class="form-control" :disabled="earnQuery.rdoPoint==='1'" v-model="earnQuery.sdate">
                    </div>
                    <label class="mt-3">至</label>
                    <div class="col-lg-3 mt-2">
                      <input type="date" class="form-control" :disabled="earnQuery.rdoPoint==='1'" v-model="earnQuery.edate">
                    </div>
                    <div class="col-lg-3 mt-2">
                      <button type="submit" class="btn btn-warning text-white">查詢</button>
                    </div>
                  </form>
                </b-form-radio-group>
                <hr>
                <div class="row">
                  <div class="col-lg-3">累積總點數：{{earnData.totalPoints}}</div>
                  <div class="col-lg-3">門市消費贈點：{{earnData.consumptionPoints}}</div>
                  <div class="col-lg-3">線上點餐消費贈點：{{earnData.appconsumptionPoints}}</div>
                  <div class="col-lg-3">活動贈點：{{earnData.activityPoints}}</div>
                </div>
                <div v-for="x in earnData.distinguishedByBrand" v-if="x.brandCode" class="row">
                  <div class="col-lg-3">累積總點數({{ x.brandCode }})：{{ x.totalbonus }}</div>
                  <div class="col-lg-3">門市消費贈點({{ x.brandCode }})：{{ x.consumption }}</div>
                  <div class="col-lg-3">線上點餐消費贈點({{ x.brandCode }})：{{ x.appconsumption }}</div>
                  <div class="col-lg-3">活動贈點({{ x.brandCode }})：{{ x.activity }}</div>
                </div>
              </div>
              <h4 class="mt-4">兌換點數查詢</h4>
              <div class="p-4 box-shadow">
                <b-form-radio-group v-model="redeemQuery.rdoPoint">
                  <form class="row" @submit.prevent="getRedeemData">
                    <div class="col-lg-12">
                      <b-form-radio value="1">總兌換點數</b-form-radio>
                    </div>
                    <div class="col-lg-2 mt-3">
                      <b-form-radio value="2">區間兌換點數</b-form-radio>
                    </div>
                    <div class="col-lg-3 mt-2">
                      <input type="date" class="form-control" :disabled="redeemQuery.rdoPoint==='1'" v-model="redeemQuery.sdate">
                    </div>
                    <label class="mt-3">至</label>
                    <div class="col-lg-3 mt-2">
                      <input type="date" class="form-control" :disabled="redeemQuery.rdoPoint==='1'" v-model="redeemQuery.edate">
                    </div>
                    <div class="col-lg-3 mt-2">
                      <button type="submit" class="btn btn-warning text-white">查詢</button>
                    </div>
                  </form>
                </b-form-radio-group>
                <hr>
                <div class="row">
                  <div class="col-lg-12">兌換總點數：{{redeemData.totalPoints}}</div>
                </div>
              </div>
              <h4 class="mt-4">到期點數查詢</h4>
              <div class="p-4 box-shadow">
                <div class="row">
                  <div class="col-lg-12">今年底到期點數：{{expiredData.thisYear}}</div>
                  <div class="col-lg-12 mt-3">到期失效點數：{{expiredData.lastYear}}</div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>會員點數報表匯出</legend>
                <vue-form class="form-horizontal form-validation p-4" :state="formstate" @submit.prevent="showPrompt">
                <b-form-radio-group v-model="memberQuery.rdoPoint">
                  <div class="row mt-3">
                  <div class="col-lg-12" style="padding-left: 10;">
                    <b-form-radio value="1">全部</b-form-radio>
                  </div>
                  </div>
                  <div class="row mt-3">
                  <div class="col-lg-2 mt-3" style="display: inline-block;padding-left: 10;">
                    <b-form-radio value="2">個人</b-form-radio>
                  </div>
                  <div class="col-lg-3 mt-2" style="display: inline-block;padding-left: 10;">
                      <validate tag="div">
                        <input v-model="memberQuery.phone" name="mobile" id="mobile" type="mobile" placeholder="請輸入會員手機號碼" class="form-control" pattern="[0-9]{10}"
                        :disabled="memberQuery.rdoPoint==='1'" :required="memberQuery.rdoPoint==='2'"/>
                        <field-messages name="mobile" show="$invalid && $submitted" class="text-danger">
                          <div slot="required">手機號碼為必填</div>
                          <div slot="pattern">手機號碼格式有誤</div>
                        </field-messages>
                      </validate>
                  </div>
                </div>
                </b-form-radio-group>
                <div class="row mt-3">
                  <label class="control-label col-md-2">性別：</label>
                  <div class="col-md-3">
                    <select class="form-control" v-model="memberQuery.sex">
                      <option value="">全部</option>
                      <option value="male">男</option>
                      <option value="female">女</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">區域：</label>
                  <div class="col-md-3">
                    <select class="form-control" v-model="memberQuery.city">
                      <option value="">全部</option>
                      <option v-for="x in city" :value="x" :key="x.id">{{x.city}}</option>
                    </select>
                  </div>
                  <label style="padding: 8px"></label>
                  <div class="col-md-3">
                    <select class="form-control" v-model="memberQuery.district" :disabled="memberQuery.city ==='0'">
                      <option value="">全部</option>
                      <option v-for="x in memberQuery.city.districts" :value="x.name" :key="x.id">{{x.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">查詢區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="memberQuery.sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="memberQuery.edate">
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2"></label>
                  <div class="col-md-7">
                    <b-form-checkbox class="mt-2" v-model="memberQuery.isPeriod">只匯出查詢區間內有點數異動的會員</b-form-checkbox>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2"></label>
                  <label class="control-label col-md-7" style='color:#FF0000;'>＊請勿於10分鐘內重複按[產檔]按紐，以免產檔發生錯誤</label>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">上次產檔時間：</label>
                  <div class="col-md-4">{{fileTime}}
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-publish">1.產檔</button>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">產檔狀態：</label>
                  <div class="col-md-4">{{ fileStatus == '0' ? '': fileStatus == '1' ? '完成' : fileStatus == '2' ? '產檔進行中' : '產檔失敗' }}
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-save" @click="exportFileGetResult">2.更新產檔進度</button>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">產檔人：</label>
                  <div class="col-md-4">{{fileUserName}}
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-save" @click="exportFileDownload" :disabled="fileStatus !== 1">3.下載csv</button>
                  </div>
                </div>
              </vue-form>
            </fieldset>
          </div>
        </div>
      </b-card>
      <!-- 預覽畫面Modal -->
      <b-modal ref="mdPrompt" hide-footer hide-header>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12" align="center">
              <span>共篩選出 {{memberQuery.downLoadQty}} 筆資料，請查看產檔進度，<br>於產檔完成後再行下載...</span>
            </div>
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { API_URL } from '../../../store/root.js'
import miniToastr from 'mini-toastr'
miniToastr.init()
export default {
  data () {
    return {
      formstate: {},
      // 累積點數查詢
      earnQuery: {
        rdoPoint: '1',
        sdate: '',
        edate: ''
      },
      earnData: {
        totalPoints: 0,
        consumptionPoints: 0,
        appconsumptionPoints: 0,
        activityPoints: 0,
        distinguishedByBrand: [{
          activity:0,
          appconsumption: 0,
          brandCode:'',
          consumption:0,
          totalbonus: 0
        }],
      },
      // 兌換點數查詢
      redeemQuery: {
        rdoPoint: '1',
        sdate: '',
        edate: ''
      },
      redeemData: {
        totalPoints: 0
      },
      // 到期點數查詢
      expiredData: {
        thisYear: 0,
        lastYear: 0
      },
      // 會員點數報表匯出
      memberQuery: {
        rdoPoint: '1',
        phone: '',
        sex: '',
        city: '',
        district: '',
        sdate: '',
        edate: '',
        downLoadQty: 0,
        isPeriod: false
      },
      city: [],
      downLoadQty: 0,
      fileTime: '',
      LoginUserName: '',
      fileName: '',
      fileUserName: '',
      fileStatus: ''
    }
  },
  created () {
    this.initQuery()
    this.getpost1()
    this.getEarnData()
    this.getRedeemData()
    this.getExpiredData()
    this.LoginUserName = localStorage.getItem('LoginUserName')
    this.exportFileGetResult()
  },
  watch: {
    'memberQuery.city': {
      handler: function (val, oldval) {
        this.memberQuery.district = ''
      },
      deep: true
    },
    'memberQuery.rdoPoint': {
      handler: function (val, oldval) {
        this.memberQuery.phone = ''
      },
      deep: true
    }
  },
  methods: {
    // 初始時間
    initQuery () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 0)
      // 若三個月後的最後一天比當天的日期大，則可以設定當天日期為三個月後的日期
      if (firstDay.getDate() >= date.getDate()) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 3, date.getDate())
      }
      var lastDay = date
      var sdate = this.dateFormat(firstDay)
      var edate = this.dateFormat(lastDay)
      this.earnQuery.sdate = this.redeemQuery.sdate = this.memberQuery.sdate = sdate
      this.earnQuery.edate = this.redeemQuery.edate = this.memberQuery.edate = edate
    },
    dateFormat (date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      return year + '-' + mon + '-' + day
    },
    /* ====累積點數查詢==== */
    getEarnData () {
      var sdate = this.earnQuery.sdate
      var edate = this.earnQuery.edate
      if (this.earnQuery.rdoPoint === '1') {
        sdate = '0001-01-01'
        edate = '9999-12-31'
      }
      if (!this.verification(sdate, edate)) return
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/getearndatas/v1', {
        sdate: sdate.replace('-', '').replace('-', '') + '000000',
        edate: edate.replace('-', '').replace('-', '') + '235959',
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.earnData.totalPoints = response.data.totalbonus
            this.earnData.consumptionPoints = response.data.consumption
            this.earnData.activityPoints = response.data.activity
            this.earnData.appconsumptionPoints = response.data.appconsumption
            this.earnData.distinguishedByBrand = response.data.distinguishedByBrand
            console.log("???",this.earnData.distinguishedByBrand)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* ====兌換點數查詢==== */
    getRedeemData () {
      var sdate = this.redeemQuery.sdate
      var edate = this.redeemQuery.edate
      if (this.redeemQuery.rdoPoint === '1') {
        sdate = '0001-01-01'
        edate = '9999-12-31'
      }
      if (!this.verification(sdate, edate)) return
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/getredeemdatas/v1', {
        sdate: sdate.replace('-', '').replace('-', '') + '000000',
        edate: edate.replace('-', '').replace('-', '') + '235959'
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.redeemData.totalPoints = Math.abs(response.data.totalbonus)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* ====到期點數查詢==== */
    getExpiredData () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/getexpireddatas/v1', {})
        .then((response) => {
          if (response.data.result === '0000') {
            this.expiredData.thisYear = response.data.totalbonus
            this.expiredData.lastYear = response.data.expiredbonus
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* ====驗證查詢時間==== */
    verification (sdate, edate) {
      var bRef = true
      if (sdate && edate) {
        // 轉換時間
        var start = new Date(sdate)
        var end = new Date(edate)
        // 比對時間
        if (end < start) {
          miniToastr.error('開始時間不可大於結束時間', '錯誤訊息')
          bRef = false
        }
      }
      return bRef
    },
    /* ====兌換點數查詢==== */
    getpost1 () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/post1/v1', {
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.city = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    /* exportFile () {
      var sdate = this.memberQuery.sdate
      var edate = this.memberQuery.edate
      var phone = this.memberQuery.phone
      if (sdate === '') { sdate = '0001-01-01' }
      if (edate === '') { edate = '9999-12-31' }
      if (!this.verification(sdate, edate)) return
      return axios({
        method: 'post',
        url: API_URL + '/web/information/exportmemberpoints',
        data: {
          mobile: phone,
          gender: this.memberQuery.sex,
          city: this.memberQuery.city.city,
          district: this.memberQuery.district,
          sdate: sdate.replace('-', '').replace('-', '') + '000000',
          edate: edate.replace('-', '').replace('-', '') + '235959'
        },
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.createDownload('會員分析_' + this.dateFormat_All(new Date()) + '.csv', response.data)
          this.$refs.mdPrompt.hide()
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
    }, */
    createDownload (fileName, content) {
      var blob = new Blob([content])
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 建立下載的連結
      downloadElement.href = href
      downloadElement.download = fileName // 下載後文檔名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 點選下載
      document.body.removeChild(downloadElement) // 下載完成移除元素
      window.URL.revokeObjectURL(href) // 釋放掉blob物件
    },
    dateFormat_All (date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      var hour = ('0' + date.getHours()).substr(-2, 2)
      var min = ('0' + date.getMinutes()).substr(-2, 2)
      var sec = ('0' + date.getSeconds()).substr(-2, 2)
      var msec = ('0' + date.getMilliseconds()).substr(-3, 3)
      return year + mon + day + hour + min + sec + msec
    },
    showPrompt () {
      var sdate = this.memberQuery.sdate
      var edate = this.memberQuery.edate
      if (sdate === '') { sdate = '0001-01-01' }
      if (edate === '') { edate = '9999-12-31' }
      if (this.formstate.$invalid) {
        return
      }
      if (!this.verification(sdate, edate)) return
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/exportmemberpointsdownloadqty', {
        mobile: this.memberQuery.phone,
        gender: this.memberQuery.sex,
        city: this.memberQuery.city.city,
        district: this.memberQuery.district,
        sdate: sdate.replace('-', '').replace('-', '') + '000000',
        edate: edate.replace('-', '').replace('-', '') + '235959',
        isPeriod: this.memberQuery.isPeriod
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.memberQuery.downLoadQty = response.data.downLoadQty
            this.$refs.mdPrompt.show()
            this.exportFile()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    exportFile () {
      var sdate = this.memberQuery.sdate
      var edate = this.memberQuery.edate
      var phone = this.memberQuery.phone
      if (sdate === '') { sdate = '0001-01-01' }
      if (edate === '') { edate = '9999-12-31' }
      if (!this.verification(sdate, edate)) return
      return axios({
        method: 'post',
        url: API_URL + '/web/information/exportmemberpoints/export',
        data: {
          mobile: phone,
          gender: this.memberQuery.sex,
          city: this.memberQuery.city.city,
          district: this.memberQuery.district,
          sdate: sdate.replace('-', '').replace('-', '') + '000000',
          edate: edate.replace('-', '').replace('-', '') + '235959',
          userName: this.LoginUserName,
          isPeriod: this.memberQuery.isPeriod
        }
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.exportFileGetResult()
            this.$refs.mdPrompt.hide()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
    },
    exportFileDownload () {
      return axios({
        method: 'post',
        url: API_URL + '/web/information/exportmemberpoints/download',
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.createDownload('會員分析_' + this.fileName, response.data)
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
    },
    exportFileGetResult () {
      return axios({
        method: 'post',
        url: API_URL + '/web/information/exportmemberpoints/getResult'
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.fileTime = response.data.fileTime
            this.fileName = response.data.fileName
            this.fileUserName = response.data.fileUserName
            this.fileStatus = response.data.fileStatus
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
    },
    checkPhoneCode () {
      var passcodeInput = document.querySelector('#phonecode')
      passcodeInput.setCustomValidity('')
      if (passcodeInput.value !== '') {
        passcodeInput.setCustomValidity('手機格式不符。範例:0910123456')
      }
    }
  }
}
</script>
<style scoped>
fieldset {
  padding: 8px 22px 18px;
  margin: 0 0 18px;
  border: 1px solid #519b39;
}
legend {
  padding: 0.2em;
  border: 0;
  width: auto;
  color: #519b39;
}
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/points/List.vue